"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// TODO: add responsive behaviour and trigger a change from table to list for small screen -> see DriverAdministration
var TableViewToggles = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TableViewToggles, _Component);

  var _super = _createSuper(TableViewToggles);

  function TableViewToggles(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TableViewToggles);
    _this = _super.call(this, props);
    _this.state = {
      viewType: _this.props.initialViewType
    };
    _this.handleSetTableView = _this.handleSetTableView.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSetSingleCardsView = _this.handleSetSingleCardsView.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSetMultiCardsView = _this.handleSetMultiCardsView.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  } // eslint-disable-next-line camelcase


  (0, _createClass2.default)(TableViewToggles, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.viewType !== nextProps.viewType) {
        this.setState({
          viewType: nextProps.viewType
        });
      }
    }
  }, {
    key: "handleSetTableView",
    value: function handleSetTableView() {
      this.setState({
        viewType: TableViewToggles.VIEW_TYPE_TABLE
      });
      this.props.onViewTypeChange(TableViewToggles.VIEW_TYPE_TABLE);
    }
  }, {
    key: "handleSetSingleCardsView",
    value: function handleSetSingleCardsView() {
      this.setState({
        viewType: TableViewToggles.VIEW_TYPE_SINGLE_CARD
      });
      this.props.onViewTypeChange(TableViewToggles.VIEW_TYPE_SINGLE_CARD);
    }
  }, {
    key: "handleSetMultiCardsView",
    value: function handleSetMultiCardsView() {
      this.setState({
        viewType: TableViewToggles.VIEW_TYPE_MULTI_CARDS
      });
      this.props.onViewTypeChange(TableViewToggles.VIEW_TYPE_MULTI_CARDS);
    }
  }, {
    key: "render",
    value: function render() {
      var viewType = this.state.viewType;
      var _this$props = this.props,
          className = _this$props.className,
          disabledViewTypes = _this$props.disabledViewTypes,
          disabled = _this$props.disabled;
      var wrapperClassNames = (0, _classnames.default)('TableViewToggles', 'btn-group', 'display-flex', 'flex-row', className && className);
      var buttonClassNames = (0, _classnames.default)('btn btn-default btn-icon-only', disabled && 'disabled pointer-events-none');
      var tableViewActiveClasses = (0, _classnames.default)(buttonClassNames, viewType === TableViewToggles.VIEW_TYPE_TABLE && 'active');
      var cardViewActiveClasses = (0, _classnames.default)(buttonClassNames, viewType === TableViewToggles.VIEW_TYPE_SINGLE_CARD && 'active');
      var multiCardsViewActiveClasses = (0, _classnames.default)(buttonClassNames, viewType === TableViewToggles.VIEW_TYPE_MULTI_CARDS && 'active');
      return /*#__PURE__*/_react.default.createElement("div", {
        className: wrapperClassNames
      }, !disabledViewTypes.includes(TableViewToggles.VIEW_TYPE_TABLE) && /*#__PURE__*/_react.default.createElement("button", {
        className: tableViewActiveClasses,
        type: "button",
        onClick: this.handleSetTableView
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "rioglyph rioglyph-table-view"
      })), !disabledViewTypes.includes(TableViewToggles.VIEW_TYPE_SINGLE_CARD) && /*#__PURE__*/_react.default.createElement("button", {
        className: cardViewActiveClasses,
        type: "button",
        onClick: this.handleSetSingleCardsView
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "rioglyph rioglyph-th-list"
      })), !disabledViewTypes.includes(TableViewToggles.VIEW_TYPE_MULTI_CARDS) && /*#__PURE__*/_react.default.createElement("button", {
        className: multiCardsViewActiveClasses,
        type: "button",
        onClick: this.handleSetMultiCardsView
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "rioglyph rioglyph-split-view"
      })));
    }
  }]);
  return TableViewToggles;
}(_react.Component);

TableViewToggles.VIEW_TYPE_TABLE = 'TABLE';
TableViewToggles.VIEW_TYPE_SINGLE_CARD = 'SINGLE_CARD';
TableViewToggles.VIEW_TYPE_MULTI_CARDS = 'MULTI_CARDS';
TableViewToggles.defaultProps = {
  initialViewType: TableViewToggles.VIEW_TYPE_TABLE,
  onViewTypeChange: function onViewTypeChange() {},
  disabledViewTypes: [],
  disabled: false
};
TableViewToggles.propTypes = {
  viewType: _propTypes.default.oneOf([TableViewToggles.VIEW_TYPE_TABLE, TableViewToggles.VIEW_TYPE_SINGLE_CARD, TableViewToggles.VIEW_TYPE_MULTI_CARDS]),
  initialViewType: _propTypes.default.oneOf([TableViewToggles.VIEW_TYPE_TABLE, TableViewToggles.VIEW_TYPE_SINGLE_CARD, TableViewToggles.VIEW_TYPE_MULTI_CARDS]),
  disabledViewTypes: _propTypes.default.arrayOf(_propTypes.default.oneOf([TableViewToggles.VIEW_TYPE_TABLE, TableViewToggles.VIEW_TYPE_SINGLE_CARD, TableViewToggles.VIEW_TYPE_MULTI_CARDS])),
  onViewTypeChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = TableViewToggles;
exports.default = _default;